import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["static"],
    _excluded2 = ["unmount"],
    _excluded3 = ["as", "children", "refName"];
import "core-js/modules/es.object.from-entries.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment as T, cloneElement as R, createElement as x, forwardRef as E, isValidElement as b } from "react";
import { classNames as N } from './class-names.js';
import { match as S } from './match.js';

var j = function (a) {
  return a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a;
}(j || {}),
    w = function (e) {
  return e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e;
}(w || {});

function D(_ref) {
  var r = _ref.ourProps,
      t = _ref.theirProps,
      e = _ref.slot,
      a = _ref.defaultTag,
      s = _ref.features,
      _ref$visible = _ref.visible,
      n = _ref$visible === void 0 ? !0 : _ref$visible,
      l = _ref.name;
  var o = h(t, r);
  if (n) return m(o, e, a, l);
  var f = s != null ? s : 0;

  if (f & 2) {
    var _o$static = o.static,
        i = _o$static === void 0 ? !1 : _o$static,
        u = _objectWithoutProperties(o, _excluded);

    if (i) return m(u, e, a, l);
  }

  if (f & 1) {
    var _S;

    var _o$unmount = o.unmount,
        _i = _o$unmount === void 0 ? !0 : _o$unmount,
        _u = _objectWithoutProperties(o, _excluded2);

    return S(_i ? 0 : 1, (_S = {}, _defineProperty(_S, 0, function _() {
      return null;
    }), _defineProperty(_S, 1, function _() {
      return m(_objectSpread(_objectSpread({}, _u), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), e, a, l);
    }), _S));
  }

  return m(o, e, a, l);
}

function m(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var e = arguments.length > 2 ? arguments[2] : undefined;
  var a = arguments.length > 3 ? arguments[3] : undefined;
  var y;

  var _g = g(r, ["unmount", "static"]),
      _g$as = _g.as,
      s = _g$as === void 0 ? e : _g$as,
      n = _g.children,
      _g$refName = _g.refName,
      l = _g$refName === void 0 ? "ref" : _g$refName,
      o = _objectWithoutProperties(_g, _excluded3),
      f = r.ref !== void 0 ? _defineProperty({}, l, r.ref) : {},
      i = typeof n == "function" ? n(t) : n;

  "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(t));
  var u = {};

  if (t) {
    var d = !1,
        c = [];

    for (var _i2 = 0, _Object$entries = Object.entries(t); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          p = _Object$entries$_i[0],
          F = _Object$entries$_i[1];

      typeof F == "boolean" && (d = !0), F === !0 && c.push(p);
    }

    d && (u["data-headlessui-state"] = c.join(" "));
  }

  if (s === T && Object.keys(P(o)).length > 0) {
    if (!b(i) || Array.isArray(i) && i.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(a, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(o).map(function (p) {
      return "  - ".concat(p);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (p) {
      return "  - ".concat(p);
    }).join("\n")].join("\n"));

    var _d = N((y = i.props) == null ? void 0 : y.className, o.className),
        _c = _d ? {
      className: _d
    } : {};

    return R(i, Object.assign({}, h(i.props, P(g(o, ["ref"]))), u, f, O(i.ref, f.ref), _c));
  }

  return x(s, Object.assign({}, g(o, ["ref"]), s !== T && f, s !== T && u), i);
}

function O() {
  for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
    r[_key] = arguments[_key];
  }

  return {
    ref: r.every(function (t) {
      return t == null;
    }) ? void 0 : function (t) {
      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var e = _step.value;
          e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
}

function h() {
  var a;

  for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    r[_key2] = arguments[_key2];
  }

  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  var t = {},
      e = {};

  for (var _i3 = 0, _r = r; _i3 < _r.length; _i3++) {
    var s = _r[_i3];

    for (var n in s) {
      n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
    }
  }

  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map(function (s) {
    return [s, void 0];
  })));

  var _loop = function _loop(_s) {
    Object.assign(t, _defineProperty({}, _s, function (n) {
      var o = e[_s];

      for (var _len3 = arguments.length, l = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        l[_key3 - 1] = arguments[_key3];
      }

      var _iterator2 = _createForOfIteratorHelper(o),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var f = _step2.value;
          if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
          f.apply(void 0, [n].concat(l));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }));
  };

  for (var _s in e) {
    _loop(_s);
  }

  return t;
}

function L(r) {
  var t;
  return Object.assign(E(r), {
    displayName: (t = r.displayName) != null ? t : r.name
  });
}

function P(r) {
  var t = Object.assign({}, r);

  for (var e in t) {
    t[e] === void 0 && delete t[e];
  }

  return t;
}

function g(r) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var e = Object.assign({}, r);

  var _iterator3 = _createForOfIteratorHelper(t),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var a = _step3.value;
      a in e && delete e[a];
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return e;
}

export { j as Features, w as RenderStrategy, P as compact, L as forwardRefWithAs, D as render };